import { IconDownload } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { MouseEventHandler } from 'react';

type Props = {
  onDownload: MouseEventHandler<HTMLButtonElement>;
  isDisabled?: boolean;
};

export const DownloadButton = ({ onDownload, isDisabled = false }: Props) => {
  return (
    <ActionIcon size="md" disabled={isDisabled} onClick={onDownload}>
      <IconDownload />
    </ActionIcon>
  );
};
